import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../../assets/logo_plantando.png";
import relatorios_icon from "../../../assets/icons/relatorios.svg";
import gerenciamento_icon from "../../../assets/icons/gerenciamento.svg";
import perfil_icon from "../../../assets/icons/perfil.svg";
import grupos_icon from "../../../assets/icons/grupos.svg";
import mapa_icon from "../../../assets/icons/mapa.svg";
import plantar_icon from "../../../assets/icons/plantar.svg";
import logout_icon from "../../../assets/icons/logout.svg";
import { mapDispatchToProps, mapStateToProps } from "../../../utils/config";
import Usuario from "../../../models/Usuario";
import DeleteDialog from "../DeleteDialog";
import { usePendentesPorTipo } from "./usePendentes";
import useMenuColapsavel from "../SideBar/useMenuColapsavel";
import BotaoColapsar from "../SideBar/BotaoColapsar";
import { Content } from "./styled";

// Itens do ambiente administrativo. `exato` evita que "Painel" (/admin) fique
// marcado em todas as páginas /admin/*.
const ITENS = [
  { para: "/admin", rotulo: "Painel", icone: mapa_icon, exato: true },
  { para: "/admin/relatorios", rotulo: "Relatórios", icone: relatorios_icon },
  { para: "/admin/usuarios", rotulo: "Usuários", icone: perfil_icon },
  { para: "/admin/grupos", rotulo: "Grupos", icone: grupos_icon },
  { para: "/admin/pedidos", rotulo: "Pedidos", icone: grupos_icon, selo: true },
  { para: "/admin/conteudo", rotulo: "Conteúdo", icone: gerenciamento_icon },
];

/**
 * Casca do ambiente administrativo (/admin/*): menu próprio, separado da
 * jornada do usuário (SideBar). Só administrador chega aqui — a proteção é do
 * RotaAdministrador nas rotas e, de verdade, do backend.
 */
function AdminLayout({ usuario, children, setUsuario }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const [colapsado, alternarMenu] = useMenuColapsavel();
  const pendentes = usePendentesPorTipo(usuario?.tipo === "Administrador");

  function logout() {
    sessionStorage.removeItem("usuario");
    setUsuario(Usuario.model);
    navigate("/login");
  }

  const ativo = (item) => (item.exato ? pathname === item.para : pathname.startsWith(item.para));

  return (
    <Content>
      <div className={`sidebar ${colapsado ? "colapsado" : ""}`} id="menu-admin">
        <BotaoColapsar colapsado={colapsado} onClick={alternarMenu} controla="menu-admin" />
        <div className="top-logo">
          <img src={logo} alt="Logo Plantando para o planeta" />
        </div>
        <span className="tag-admin">Administração</span>

        <nav aria-label="Menu da administração">
          {ITENS.map((item) => (
            <Link key={item.para} to={item.para}
              className={`nav-item ${ativo(item) ? "active" : ""}`}
              title={colapsado ? item.rotulo : undefined}
              aria-current={ativo(item) ? "page" : undefined}>
              <img src={item.icone} alt="" />
              <span>{item.rotulo}</span>
              {item.selo && pendentes.total > 0 &&
                <b className="badge" aria-label={`${pendentes.total} pedidos pendentes: ${pendentes.profissional} de perfil Profissional, ${pendentes.apoiador} de apoiador e ${pendentes.patrocinador} de patrocinador`}>{pendentes.total}</b>
              }
            </Link>
          ))}

          <div className="separador" role="separator" />

          <Link to="/plantar" className="nav-item" title={colapsado ? "Área do usuário" : undefined}>
            <img src={plantar_icon} alt="" />
            <span>Área do usuário</span>
          </Link>

          <button type="button" className="nav-item" title={colapsado ? "Sair" : undefined} onClick={() => setShowLogout(true)}>
            <img src={logout_icon} alt="" />
            <span>Sair</span>
          </button>
        </nav>
      </div>

      <div className="panel">
        {children}
      </div>

      {showLogout &&
        <DeleteDialog
          titulo={"Sair da conta"}
          subtitulo={"Deseja realmente sair da conta?"}
          onClose={() => setShowLogout(false)}
          textButton={"Sair"}
          onDelete={logout}
        />
      }
    </Content>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);
